import { render, staticRenderFns } from "./delete-item.vue?vue&type=template&id=5a39c54a&scoped=true"
import script from "./delete-item.vue?vue&type=script&lang=js"
export * from "./delete-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39c54a",
  null
  
)

export default component.exports